import React, {useEffect, useRef, useState} from "react";
import {ChevronDownIcon} from "@radix-ui/themes";
import './MetaNavigation.css';

function MetaNavigation() {
    const [open, setOpen] = useState(false);
    const buttonRef = useRef(null);
    const dropdownRef = useRef(null);

    const toggleOpen = () => setOpen(prev => !prev);

    useEffect(() => {
        function handleClickOutside(event) {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target) &&
                buttonRef.current &&
                !buttonRef.current.contains(event.target)
            ) {
                setOpen(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <nav className="meta-nav-container">
            <div className="meta-nav-content">
                <div className="meta-nav-list">
                    <button
                        className={`meta-nav-trigger ${open ? 'open' : ''}`}
                        onClick={toggleOpen}
                        aria-haspopup="true"
                        aria-expanded={open}
                        ref={buttonRef}
                    >
                        Behörden <ChevronDownIcon className="dropdown-icon"/>
                    </button>
                    {open && (
                        <div
                            className="meta-navigation-content"
                            role="menu"
                            ref={dropdownRef}
                        >
                            <ul>
                                <li className="meta-nav-list-item">
                                    <a href="https://lfu.rlp.de/" target="_blank" rel="noreferrer"
                                       aria-label="Zur Webseite des Landesamt für Umwelt Rheinland-Pfalz">LfU</a>
                                </li>
                                <li className="meta-nav-list-item">
                                    <a href="https://sgdsued.rlp.de/" target="_blank" rel="noreferrer"
                                       aria-label="Zur Webseite der SGD Süd">SGD Süd</a>
                                </li>
                                <li className="meta-nav-list-item">
                                    <a href="https://sgdnord.rlp.de/" target="_blank" rel="noreferrer"
                                       aria-label="Zur Webseite der SGD Nord">SGD Nord</a>
                                </li>
                            </ul>
                        </div>
                    )}
                </div>
            </div>
        </nav>
    );
}

export default MetaNavigation;
